import Vue from 'vue';
import autosize from 'autosize';

/**
 * Declares all the directives of the project
 */
export function initDirectives() {
    /**
     * Uses Jack Moore's autosize (http://www.jacklmoore.com/autosize/) in order to resize a
     * textarea automatically.
     *
     * Use this directive with `v-autosize` on a textarea.
     */
    Vue.directive('autosize', {
        bind: function () {
            autosize(this.el);
            this.el.style.resize = 'none';

            Vue.nextTick(() => {
                autosize.update(this.el);
            });
        },
        unbind: function () {
            autosize.destroy(this.el);
        }
    });
}



// WEBPACK FOOTER //
// ./src/directives.js